//----------------------------------------------- 
export module Plegma {
  export const enum eBinaryResourceContentType {
    Undefined = 0,
    Data = 1,
    Text = 2,
    Image = 3,
    Audio = 4,
    Video = 5
  }
  export const enum eBinaryResourceLocationType {
    Undefined = 0,
    Http = 1,
    RedisDB = 2
  }
  export const enum eConnectionFlags {
    None = 0,
    CreateNewEndpoint = 1,
    IsMasterEndpoint = 2,
    KillExistingNodeLinks = 4
  }
  export const enum eEndpointRestrictions {
    None = 0,
    SkipThingsSync = 1,
    SkipPortStateSync = 2,
    DelayRxPathOpen = 4
  }
  export const enum eMsgFlags {
    None = 0,
    Request = 1,
    Response = 2
  }
  export const enum eNodeCapa {
    None = 0,
    SupportsGraphSolving = 1,
    Scannable = 2,
    IsWarlock = 4,
    IsShellNode = 8
  }
  export const enum eNodeType {
    Unknown = 0,
    Generic = 1,
    EndpointSingle = 2,
    TestGateway = 3,
    TestEndpoint = 4,
    WSEndpoint = 5,
    Android = 6,
    iOS = 7,
    SmartThingsEndPoint = 8,
    mNode = 9,
    Dashboard = 10,
    LoRa = 11,
    Impact = 12,
    ImpactV2 = 13,
    Facebook = 14,
    Skype = 15,
    Sigfox = 16,
    WSSample = 200,
    RestSample = 201,
    Virtual = 202,
    Yodikit = 203
  }
  export const enum ePortConf {
    None = 0,
    PropagateAllEvents = 1,
    IsTrigger = 2,
    DoNotNormalize = 4,
    SupressIdenticalEvents = 8,
    Hidden = 16,
    IsMetadata = 32
  }
  export const enum ePortStateOperation {
    Invalid = 0,
    SpecificKeys = 1,
    ActivePortStates = 2,
    AllPortStates = 3,
    ActivePortKeys = 4,
    AllPortsNoStates = 5
  }
  export enum ePortType {
    Undefined = 0,
    Integer = 1,
    Decimal = 2,
    DecimalHigh = 3,
    Boolean = 4,
    Color = 5,
    String = 6,
    VideoDescriptor = 7,
    AudioDescriptor = 8,
    BinaryResourceDescriptor = 9,
    I2CDescriptor = 10,
    JsonString = 11,
    IncidentDescriptor = 12,
    Timestamp = 13
  }
  export const enum eThingConf {
    None = 0,
    SyncEventWithAllEndpoints = 1,
    Removable = 2
  }
  export const enum eThingSolveErrorCode {
    Received = 0,
    Sent = 1,
    Forwarded = 2,
    ThingDoesNotExist = 3,
    ThingIsNotCurrentlyConnected = 4,
    NoPendingReqFound = 5,
    InvalidReq = 6,
    Unreachable = 7,
    NoEligibleTarget = 8,
    TimeToLiveExceeded = 9,
    RejectedByThirdParty = 10,
    FateUnknown = 11,
    RejectedDueToQuota = 12,
    RejectedDueToThrottling = 13,
    LastReserved = 29,
    OtherError = 255
  }
  export const enum eThingsOperation {
    Invalid = 0,
    Update = 1,
    Overwrite = 2,
    Delete = 3,
    Get = 4,
    Scan = 5,
    Sync = 6
  }
  export const enum eUnpairReason {
    Unknown = 0,
    InvalidOperation = 1,
    UserRequested = 2,
    TooManyAuthFailures = 3
  }
  export const enum eWSMsgId {
    None = 0,
    Pairing = 1,
    Api = 2,
    Warlock = 3
  }
  export const enum ioPortDirection {
    Undefined = 0,
    InputOutput = 1,
    Output = 2,
    Input = 3
  }
  export const enum RestServiceType {
    Undefined = 0,
    Dropbox = 1,
    Pastebin = 2,
    GoogleDrive = 3,
    Yodiwo = 4
  }
  export interface ActivePortKeysMsg extends Plegma.PlegmaApiMsg {
    ActivePortKeys?: string[];
  }
  export interface BinaryResourceDescriptor {
    AutoDelete?: boolean;
    ContentDescriptorJson?: string;
    ContentType?: Plegma.eBinaryResourceContentType;
    DueDate?: number;
    DueDateStr?: string;
    FriendlyDescription?: string;
    FriendlyName?: string;
    Key?: string;
    LastFetched?: number;
    LastFetchedStr?: string;
    LocationDescriptorJson?: string;
    LocationType?: Plegma.eBinaryResourceLocationType;
    MaxFetchTimes?: number;
    Size?: number;
    TimesFetched?: number;
  }
  export interface ConfigDescription {
    DefaultValue?: string;
    Description?: string;
    Label?: string;
    Maximum?: number;
    Minimum?: number;
    Name?: string;
    ReadOnly?: boolean;
    Required?: boolean;
    Stepsize?: number;
    Type?: string;
  }
  export interface ConfigParameter {
    Description?: string;
    Name?: string;
    Value?: string;
  }
  export interface LoginRsp extends Plegma.PlegmaApiMsg {
    DesiredEndpoint?: string;
    Flags?: Plegma.eConnectionFlags;
    NodeKey?: string;
    SecretKey?: string;
  }
  export interface NodeInfoReq extends Plegma.PlegmaApiMsg {
    AssignedEndpoint?: string;
    LatestApiRev?: number;
    ThingsRevNum?: number;
  }
  export interface NodeInfoRsp extends Plegma.PlegmaApiMsg {
    AdditionalInfo?: { [key: string]: string };
    BlockLibraries?: string[];
    Capabilities?: Plegma.eNodeCapa;
    MaxMsgSize?: number;
    Name?: string;
    Restrictions?: Plegma.eEndpointRestrictions;
    SupportedApiRev?: number;
    ThingsRevNum?: number;
    ThingTypes?: Plegma.ThingType[];
    TransientInfo?: { [key: string]: string };
    Type?: Plegma.eNodeType;
  }
  export interface NodeKey {
    NodeID?: number;
    UserKey?: Plegma.UserKey;
  }
  export interface NodeUnpairedReq extends Plegma.PlegmaApiMsg {
    Message?: string;
    Nodekey?: Plegma.NodeKey;
    ReasonCode?: Plegma.eUnpairReason;
  }
  export interface PairingNodeGetKeysRequest {
    token1?: string;
    token2?: string;
  }
  export interface PairingNodeGetTokensRequest {
    description?: string;
    image?: string;
    name?: string;
    NoUUIDAuthentication?: boolean;
    PairingCompletionInstructions?: string;
    pathcss?: string;
    PublicKey?: number[];
    RedirectUri?: string;
    TargetEmail?: string;
    uuid?: string;
  }
  export interface PairingServerKeysResponse extends Plegma.GenericRsp {
    email?: string;
    nodeKey?: string;
    secretKey?: string;
  }
  export interface PairingServerTokensResponse extends Plegma.GenericRsp {
    token1?: string;
    token2?: string;
  }
  export interface PlegmaApiMsg extends Yodiwo.API.ApiMsg { }
  export interface Port {
    Color?: string;
    ConfFlags?: Plegma.ePortConf;
    Description?: string;
    ioDirection?: Plegma.ioPortDirection;
    LastUpdatedTimestamp?: number;
    Name?: string;
    PortKey?: string;
    PortModelId?: string;
    RevNum?: number;
    Semantics?: string;
    Size?: number;
    State?: string;
    Touch?: any;
    Type?: Plegma.ePortType;
    Yport?: any;
  }
  export interface PortDescription {
    Category?: string;
    Description?: string;
    Id?: string;
    ioDirection?: Plegma.ioPortDirection;
    Label?: string;
    Semantics?: string;
    State?: Plegma.StateDescription;
  }
  export interface PortEvent {
    PortKey?: string;
    RevNum?: number;
    State?: string;
    Timestamp?: number;
  }
  export interface PortEventMsg extends Plegma.PlegmaApiMsg {
    BlockKey?: string;
    INeedAck?: boolean;
    PortEvents?: Plegma.PortEvent[];
  }
  export interface PortState {
    IsDeployed?: boolean;
    PortKey?: string;
    RevNum?: number;
    State?: string;
  }
  export interface PortStateGet extends Plegma.PlegmaApiMsg {
    Operation?: Plegma.ePortStateOperation;
    PortKeys?: string[];
  }
  export interface PortStateSet extends Plegma.PlegmaApiMsg {
    Operation?: Plegma.ePortStateOperation;
    PortStates?: Plegma.PortState[];
  }
  export interface StateDescription {
    Maximum?: number;
    Minimum?: number;
    Pattern?: string;
    ReadOnly?: boolean;
    Step?: number;
    Type?: Plegma.ePortType;
  }
  export interface SubUserKey {
    UserKey?: Plegma.UserKey;
  }
  export interface Thing {
    ConfFlags?: Plegma.eThingConf;
    Config?: Plegma.ConfigParameter[];
    Hierarchy?: string;
    Name?: string;
    Ports?: Plegma.Port[];
    ReadonlyInfo?: Plegma.ConfigParameter[];
    Removable?: boolean;
    RESTUri?: string;
    ThingKey?: string;
    Type?: string;
    UIHints?: Plegma.ThingUIHints;
    Ything?: any;
  }
  export interface ThingModelType {
    Config?: Plegma.ConfigDescription[];
    Description?: string;
    Id?: string;
    Name?: string;
    NumPorts?: { [key: string]: number };
    PortModels?: { [key: string]: Plegma.PortDescription };
  }
  export interface ThingsGet extends Plegma.PlegmaApiMsg {
    Key?: string;
    Operation?: Plegma.eThingsOperation;
    RevNum?: number;
    ThingKey?: string;
  }
  export interface ThingsSet extends Plegma.PlegmaApiMsg {
    Data?: Plegma.Thing[];
    Hierarchy?: string;
    Operation?: Plegma.eThingsOperation;
    RevNum?: number;
    Status?: boolean;
  }
  export interface ThingType {
    Description?: string;
    Models?: { [key: string]: Plegma.ThingModelType };
    Searchable?: boolean;
    Type?: string;
  }
  export interface ThingUIHints {
    Description?: string;
    IconURI?: string;
  }
  export interface UserKey {
    UserID?: string;
  }
  export interface WebSocketMsg extends Yodiwo.WrapperMsg {
    Id?: Plegma.eWSMsgId;
    SubId?: string;
  }
}
//----------------------------------------------- 
export module Warlock {
  export const enum eBRDUpdateAction {
    Invalid = 0,
    Name = 1,
    AutoDelete = 2
  }
  export const enum eMsgFlags {
    None = 0,
    Request = 1,
    Response = 2
  }
  export const enum eWSMsgId {
    None = 0,
    Pairing = 1,
    Api = 2,
    Warlock = 3
  }
  export interface BRDUpdateReq extends Warlock.WarlockApiMsg {
    action?: Warlock.eBRDUpdateAction;
    brd?: Plegma.BinaryResourceDescriptor;
  }
  export interface SingleFileResp extends Warlock.GenericRsp {
    ContentType?: string;
    Description?: string;
    Guid?: string;
    LocationDescriptorJson?: string;
    Name?: string;
    Size?: number;
    Url?: string;
  }
  export interface StorageUploadReq extends Warlock.WarlockApiMsg {
    fdescription?: string;
    fname?: string;
    length?: number;
  }
  export interface StorageUploadResp extends Warlock.GenericRsp {
    AccessToken?: string;
    guid?: string;
    Uploaduri?: string;
    UserToken?: string;
    WorkerKey?: string;
    WorkerUri?: string;
  }
  export interface WarlockApiMsg extends Yodiwo.API.ApiMsg {
    AppDomainID?: string;
    SubUserKey?: Plegma.SubUserKey;
    TargetSubUserKey?: string;
    UserKey?: Plegma.UserKey;
  }
}
//----------------------------------------------- 
export module Yodiwo {
  export interface WrapperMsg {
    Flags?: Plegma.eMsgFlags;
    Payload?: string;
    PayloadSize?: number;
    SyncId?: number;
  }
}
//----------------------------------------------- 
export module Yodiwo.API {
  export interface ApiMsg {
    SeqNo?: number;
  }
}
//----------------------------------------------- 
export module Plegma {
  export interface GenericRsp extends Plegma.PlegmaApiMsg {
    IsSuccess?: boolean;
    Message?: string;
    OrigSeqNo?: number;
    StatusCode?: number;
  }
}
//----------------------------------------------- 
export module Warlock {
  export interface GenericRsp extends Warlock.WarlockApiMsg {
    IsSuccess?: boolean;
    Message?: string;
    StatusCode?: number;
  }
  export interface WrapperMsg {
    Flags?: Warlock.eMsgFlags;
    Payload?: string;
    PayloadSize?: number;
    SyncId?: number;
  }
}